import 'react-phone-number-input/style.css'

import { InputProps, TextField } from '@mui/material'
import { FieldInputProps, useField } from 'formik'
import { ChangeEvent, FC, forwardRef } from 'react'
import PhoneInput from 'react-phone-number-input'
import { getPxAsRem } from 'shared/utils'

interface FormikPhoneInputProps extends FieldInputProps<string> {
    fieldName: string
    disabled?: boolean
    loading?: boolean
    error?: boolean
    helperText?: string
    label: string
    value: string
    id?: string
    size?: 'small' | 'medium'
    placeholder?: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    InputProps?: Partial<InputProps>
}

const PhoneInputWithDefaultCountry = forwardRef((props: any, ref) => {
    return <PhoneInput defaultCountry="US" {...props} ref={ref} />
})

const FormikPhoneInput: FC<FormikPhoneInputProps> = ({
    fieldName,
    label,
    onChange,
    value,
    disabled,
    loading,
    error,
    helperText,
    id,
    size,
    placeholder,
    InputProps,
    ...props
}) => {
    const [, , helpers] = useField(fieldName)
    return (
        <TextField
            {...props}
            id={id}
            size={size}
            placeholder={placeholder}
            label={label}
            value={value}
            onChange={(value) => {
                helpers.setTouched(true, false)
                if (value) helpers.setValue(value, true)
                else helpers.setValue('', true)
            }}
            fullWidth
            disabled={disabled}
            error={error}
            helperText={helperText}
            sx={{
                '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                    paddingLeft: getPxAsRem(42),
                },
            }}
            InputProps={{
                onBlur: () => helpers.setTouched(true, true),
                inputComponent: PhoneInputWithDefaultCountry,
                ...InputProps,
            }}
            inputProps={{
                defaultCountry: 'US',
                sx: {
                    display: 'flex',
                    height: '100%',
                    border: 'none',
                    '.PhoneInputInput': {
                        outline: 'none',
                        height: '100%',
                        border: 'none',
                        font: 'inherit',
                        color: 'inherit',
                        letterSpacing: 'inherit',
                        '&:-webkit-autofill': {
                            WebkitBoxShadow: '0 0 0 100px #fff inset',
                        },
                    },
                },
            }}
        />
    )
}

export default FormikPhoneInput
